import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { timeout, catchError, throwError } from 'rxjs';
import { ToastService } from '@webapp/ui/components/toast/toast.service';
import { CONFIG } from '../config';
import { ERRORS } from '../texts';

/**
 * Timeout interceptor with configurable timeout and toast notification
 */
export const timeoutInterceptor: HttpInterceptorFn = (req, next) => {
  const toastService = inject(ToastService);
  const timeoutValue = CONFIG.DEFAULT_TIMEOUT;

  return next(req).pipe(
    timeout(timeoutValue),
    catchError((error) => {
      if (error.name === 'TimeoutError') {
        toastService.showToast(
          'Ocurrió un error',
          ERRORS.TIMEOUT,
          'error',
          true
        );
        return throwError(() => new Error('Request timeout'));
      }
      return throwError(() => error);
    })
  );
};